module.exports = __webpack_public_path__ + "img/sucess-img.8bfdb358.png";